module.exports = __webpack_public_path__ + "img/prd.2a11ca30.jpg";